export const subDomains = {
  beta: false
};
export const originDomains = {
  beta: true
};